import { render, staticRenderFns } from "./TabelaLinha.vue?vue&type=template&id=71ad65d6&scoped=true&lang=pug"
import script from "./TabelaLinha.vue?vue&type=script&lang=js"
export * from "./TabelaLinha.vue?vue&type=script&lang=js"
import style0 from "./TabelaLinha.styl?vue&type=style&index=0&id=71ad65d6&prod&lang=stylus&scoped=true&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71ad65d6",
  null
  
)

export default component.exports